import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const ProgressBar = ({ achieved, target }) => {
  const achievedValue = parseInt(achieved?.value) || 0;
  const targetValue = parseInt(target?.value) || 1; // Avoid division by zero
  const progress = Math.min((achievedValue / targetValue) * 100,);

  const [animatedProgress, setAnimatedProgress] = useState(0);
  useEffect(() => {
    let animation;
    if (animatedProgress < progress) {
      animation = setTimeout(() => {
        setAnimatedProgress((prev) => Math.min(prev + 1, progress)); // Increase gradually
      }, 10); // Adjust speed (lower is faster)
    }
    return () => clearTimeout(animation);
  }, [animatedProgress, progress]);
  const getProgressColor = () => {
    let red, green;

    if(progress >= 100 ){
      red = 0;
      green=255
    }
   else if (progress < 50) {
      red = 255;
      green = Math.round((progress / 50) * 255); // Increase green from 0 → 255
    } else {
      red = Math.round(255 - ((progress - 50) / 50) * 255); // Decrease red from 255 → 0
      green = 255 - Math.round(((progress - 50) / 50) * 127); // Decrease green slightly to 128
    }

    // Solid color for the progress bar
    const solidColor = `rgb(${red}, ${green}, 0)`;

    // Lighter, transparent color for the background (20% opacity)
    const lightColor = `rgba(${red}, ${green}, 0, 0.2)`;

    return { solidColor, lightColor };
  };

  const { solidColor, lightColor } = getProgressColor();
  return (
    <Paper
      sx={{
        p:1,
        px: 2,
        backgroundColor: 'transparent',
        borderRadius: 3,
        width:'100%',
        border:'1px solid rgb(83, 45, 73)',
        color:'white'
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // mt: 1,
            // mb: 0.5,
          }}
        >
          <Typography variant="subtitle2" >
            {achieved?.name || "Achieved"} : {achieved?.value || 0}
          </Typography>
          <Typography variant="subtitle2" >
            {target?.name || "Target"} : {target?.value || 0}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LinearProgress
            variant="determinate"
            value={animatedProgress}
            sx={{
              flexGrow: 1,
              height: 8,
              borderRadius: 5,
              border: "1px solidrgba(128, 128, 128, 0.23)",
              backgroundColor:progress>=100?'rgb(0, 255, 0)':lightColor, // Light transparent background
              "& .MuiLinearProgress-bar": {
                backgroundColor: solidColor, // Solid color for progress fill
              },
            }}
          />
          <Typography variant="overline" >{`${Math.round(
            progress
          )}%`}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ProgressBar;
